module.exports = __webpack_public_path__ + "static/media/clinician-watchman-device-3582w.54aa70a9.jpg";